import { useEffect, useState } from 'react';
import { ROUTE_REGION_AND_BUILDING_DATA } from '../Routes/Routes';
import usePageTitle from '../../hooks/usePageTitle';
import { BaseButton } from '../../components/BaseButton/BaseButton';
import BuildingsTable from '../BuildingsTable/BuildingsTable';
import { useAuth } from '../../hooks/useAuth';
import { Content } from '../../Enums/contents';
import './Buildings.scss';

const {
    Buttons: {
        editBuildingButtonLabel, 
        newBuildingButtonLabel,
        MUI: { 
            Variant: { 
                outlined 
            }
        }
    } 
} = Content;

const Buildings = () => {
    const [forceReload, setForceReload] = useState(false);
    const [allowEditing, setAllowEditing] = useState(false);
    const [allowCreate, setAllowCreate] = useState(false);
    const { user } = useAuth();
    const { module, title } = ROUTE_REGION_AND_BUILDING_DATA;
	const routeModule = module; 

    usePageTitle(title);

    useEffect(() => {
        const permissions = user.role.ModulePermissions?.filter(module => {
			return (module.Page == routeModule) 
		});

        setAllowEditing(permissions?.filter(module => { 
			return (module.Update) 
		}).length > 0)
        
		setAllowCreate(permissions?.filter(module => { 
			return (module.Create) 
		}).length > 0)
    },[])
  
  	return (
    	<>
			<h1 style={{ color: "#06152B" }}>{ title }</h1>
          	<BuildingsTable 
				allowEditing={allowEditing} 
				allowCreate={allowCreate} 
				forceReload={forceReload} 
				stopForceReload={() => { setForceReload(false) }} 
			/>
      		<br />
    	</>
  	);
}

export default Buildings;
